import React from "react";
import {
    FaBoxesStacked,
    FaUtensils,
    FaBottleWater,
    FaStore,
    FaCapsules,
    FaIndustry,
    FaHelmetSafety,
    FaBuilding,
} from "react-icons/fa6";
import "./sfaIndustriesServed.css";

const industries = [
    {
        id: "01",
        title: "FMCG & Consumer Goods",
        description:
            "Manage outlet coverage, beat execution, customer visits and daily sales activity across fast-moving consumer product networks.",
        icon: <FaBoxesStacked />,
        accent: "orange",
    },
    {
        id: "02",
        title: "Food & Snacks",
        description:
            "Help field teams manage retailer visits, customer engagement, order capture and day-to-day market execution.",
        icon: <FaUtensils />,
        accent: "coral",
    },
    {
        id: "03",
        title: "Beverages",
        description:
            "Improve market coverage, outlet execution and sales visibility for beverage teams working across territories.",
        icon: <FaBottleWater />,
        accent: "cyan",
    },
    {
        id: "04",
        title: "Retail & Distribution",
        description:
            "Connect sales representatives with outlets, distributors and daily customer activity through a single field workflow.",
        icon: <FaStore />,
        accent: "teal",
    },
    {
        id: "05",
        title: "Pharmaceuticals & Healthcare",
        description:
            "Support structured field visits, territory activity and customer coverage for healthcare-focused sales teams.",
        icon: <FaCapsules />,
        accent: "purple",
    },
    {
        id: "06",
        title: "Manufacturing",
        description:
            "Give field teams better visibility into customer coverage, market visits and sales execution across territories.",
        icon: <FaIndustry />,
        accent: "orange",
    },
    {
        id: "07",
        title: "Building Materials",
        description:
            "Track customer visits, market activity and sales execution across construction and building-material networks.",
        icon: <FaHelmetSafety />,
        accent: "coral",
    },
    {
        id: "08",
        title: "Real Estate",
        description:
            "Organize customer interactions, field activity and territory coverage for teams operating across real estate markets.",
        icon: <FaBuilding />,
        accent: "cyan",
    },
];

const SfaIndustriesServed = () => {
    return (
        <section className="sfa-industries-section">
            <div className="sfa-industries-bg-shape sfa-industries-bg-shape-left"></div>
            <div className="sfa-industries-bg-shape sfa-industries-bg-shape-right"></div>

            <div className="container">
                <div
                    className="sfa-industries-header"
                    data-aos="fade-up"
                >
                    <span className="sfa-industries-kicker">
                        <span className="sfa-industries-kicker-dot"></span>
                        INDUSTRIES SERVED
                    </span>

                    <h2>
                        Built for Industries
                        <span> That Sell in the Field</span>
                    </h2>

                    <p>
                        TechCognics SFA helps businesses bring field teams,
                        customer visits, outlet coverage and sales activity
                        together through one connected workflow.
                    </p>
                </div>

                <div className="sfa-industries-grid">
                    {industries.map((industry, index) => (
                        <article
                            className={`sfa-industry-card sfa-industry-${industry.accent}`}
                            key={industry.id}
                            data-aos="fade-up"
                            data-aos-delay={Math.min(index * 60, 360)}
                        >
                            <div className="sfa-industry-accent"></div>

                            <div className="sfa-industry-top">
                                <span className="sfa-industry-number">
                                    {industry.id}
                                </span>

                                <div className="sfa-industry-icon">
                                    {industry.icon}
                                </div>
                            </div>

                            <div className="sfa-industry-content">
                                <h3>{industry.title}</h3>

                                <p>{industry.description}</p>
                            </div>

                            <div className="sfa-industry-bottom">
                                <span className="sfa-industry-bottom-line"></span>

                                <span className="sfa-industry-label">
                                    FIELD SALES
                                </span>
                            </div>
                        </article>
                    ))}
                </div>

                <div
                    className="sfa-industries-footer"
                    data-aos="fade-up"
                    data-aos-delay="180"
                >
                    <span className="sfa-industries-footer-line"></span>

                    <p>
                        One platform for
                        <strong> diverse field-sales operations</strong>
                    </p>

                    <span className="sfa-industries-footer-line"></span>
                </div>
            </div>
        </section>
    );
};

export default SfaIndustriesServed;